/** @jsxImportSource preact */
import { h } from 'preact';

export type ViewMode = 'counts' | 'proportion';

interface ViewModeToggleProps {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
  isMobile: boolean;
  countsLabel?: string;
  proportionLabel?: string;
}

export function ViewModeToggle({
  viewMode,
  onViewModeChange,
  countsLabel = 'Document counts',
  proportionLabel = 'Proportion of documents',
}: ViewModeToggleProps) {
  const otherMode = viewMode === 'counts' ? 'proportion' : 'counts';
  const otherLabel = otherMode === 'counts' ? countsLabel : proportionLabel;

  return (
    <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, fontSize: 11, whiteSpace: 'nowrap' }}>
      <span style={{ color: 'var(--gc-text-muted, #6b7280)' }}>View by:</span>
      <button
        type="button"
        title="Toggle chart view"
        onClick={() => onViewModeChange(otherMode)}
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          fontSize: 11,
          color: 'var(--gc-link, inherit)',
          textDecoration: 'underline',
          fontWeight: 400,
          cursor: 'pointer',
        }}
      >
        {otherLabel}
      </button>
    </div>
  );
}
